// EVENTS.VIEWS.APP.REWARDS.REDEEM.VIEW_REWARD

export const VIEW_REWARD = {
  PAGE_VISITED: 'reward-page_visited',
  DOWNLOAD_REWARD: 'reward-download'
};
